module.exports = __webpack_public_path__ + "img/color-checked-icon.76e30362.svg";